var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import changeProject from '../../api/queries/changeProject';
import BrowserStorage from '../../api/queries/browserStorage';
import { ProjectActionContainer, ProjectAdderContainer, ProjectAdderBtn, ProjectAdderBtnTxt, ProjectContainer, ProjectDataContainer, ProjectActionBtn, ProjectListContainer, ProjectText, ProjectsContainer, } from './styled';
/**
 * The handler that calls the change project function (changeProject),
 *
 * @param e React synthetic event.
 * @param onBeforeChangeProject
 * @param onSelectProject
 * @param isNeedToShowCode The flag that determines whether to redirect
 * to the code page.
 */
function onChangeProject(e, onBeforeChangeProject, onSelectProject) {
    onBeforeChangeProject();
    var id = e.currentTarget.getAttribute('data-id');
    if (id === null)
        throw new Error();
    return changeProject(id).then(function () { return onSelectProject(id); });
    // if (isNeedToShowCode) {
    //   location.href = '#code/standart';
    // };
}
/**
 * Accepts a collection and forms a list of projects from it.
 */
function ProjectList(props) {
    var _this = this;
    var projectHandler = function (e, isNeedToShowCode) {
        if (isNeedToShowCode === void 0) { isNeedToShowCode = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var currentProjectId, projectId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentProjectId = sessionStorage.getItem(BrowserStorage.ProjectId) ||
                            window.app.currentProjectId;
                        projectId = e.currentTarget.getAttribute('data-id');
                        if (!(projectId !== currentProjectId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, onChangeProject(e, props.onBeforeChangeProject, props.onSelectProject)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isNeedToShowCode) {
                            location.href = '#settings/code';
                        }
                        props.onClickProject();
                        return [2 /*return*/];
                }
            });
        });
    };
    return (_jsx(ProjectListContainer, { children: props.collectionOfProjects.map(function (m) { return (_jsxs(ProjectContainer, { children: [_jsxs(ProjectDataContainer, __assign({ "data-id": m.id, onClick: function (e) { return projectHandler(e); } }, { children: [_jsxs(ProjectText, __assign({ weight: "bold" }, { children: ["#", m.id] }), void 0),
                        _jsx(ProjectText, { children: m.name }, void 0)] }), void 0),
                _jsxs(ProjectActionContainer, { children: [window.app.Models.User.get('access_projects_edit') &&
                            window.app.Models.User.get('access_projects_create') ? (_jsx(ProjectActionBtn, __assign({ "data-id": m.id, "data-modal": "copy_project", onClick: function (e) { return props.onShowModal(e); } }, { children: _jsx("i", { className: "fa fa-clone" }, void 0) }), void 0)) : (''),
                        _jsx(ProjectActionBtn, __assign({ "data-id": m.id, onClick: function (e) { return projectHandler(e, true); } }, { children: _jsx("i", { className: "fa fa-code" }, void 0) }), void 0),
                        window.app.Models.User.get('access_projects_edit') ? (_jsx(ProjectActionBtn, __assign({ "data-id": m.id, "data-modal": "edit_project", onClick: function (e) { return props.onShowModal(e); } }, { children: _jsx("i", { className: "fa fa-pencil" }, void 0) }), void 0)) : ('')] }, void 0)] }, m.id)); }) }, void 0));
}
/**
 * Accepts a collection and render projects.
 *
 * @param props.collectionOfProjects This is a collection containing
 * an array of projects
 * @param props.onBeforeChangeProject This is Backbone global event.
 * Temporary parameter, until a new module is created.
 * @param props.onSelectProject This is Backbone global event.
 * Temporary parameter, until a new module is created.
 * @param props.onShowModal This is Marionette behavior.
 * Temporary parameter, until a new module is created.
 */
function Projects(props) {
    return (_jsxs(ProjectsContainer, { children: [window.app.Models.User.get('access_projects_create') ? (_jsx(ProjectAdderContainer, { children: _jsx(ProjectAdderBtn, __assign({ "data-modal": "edit_project", onClick: props.onShowModal }, { children: _jsx(ProjectAdderBtnTxt, { children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442" }, void 0) }), void 0) }, void 0)) : (''),
            _jsx(ProjectList, __assign({}, props), void 0)] }, void 0));
}
export default Projects;
